import { differenceInDays, format } from "date-fns";
import { useMemo, useState } from "react";
import { useQuery } from "react-query";

import { normalizeFaceAnalytics } from "~/entity/Ivideon/lib/normalizeAnalytics";
import { IvideonAnalyticsIProps } from "~/entity/Ivideon/model/schema";
import { ParseForServerResultIProps } from "~/widgets/Filters/FilterSummary/schema/types";

import { useIvideon } from "./useIvideon";

export const useGetFaceAnalytics2 = () => {
  const [params, setParams] = useState<IvideonAnalyticsIProps | null>(null);
  const [dates, setDates] = useState<{ startDate: Date; endDate: Date } | null>(
    null,
  );
  const { ivideonFaceAnalytics } = useIvideon();

  const setParamsFilter = (props: ParseForServerResultIProps) => {
    const difference = differenceInDays(
      new Date(props.endDate),
      new Date(props.startDate),
    );

    const formatProps: IvideonAnalyticsIProps = {
      ...props,
      groupBy: difference > 0 ? "day" : "hour",
      startDate: format(new Date(props.startDate), "yyyy-MM-dd"),
      endDate: format(new Date(props.endDate), "yyyy-MM-dd"),
    };
    setParams(formatProps);
    setDates({
      startDate: props.startDate,
      endDate: props.endDate,
    });
  };

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["face-analytics", params],
    queryFn: () => ivideonFaceAnalytics(params!),
    refetchOnWindowFocus: false,
    enabled: !!params,
  });

  const normalizedData = useMemo(
    () => (data ? normalizeFaceAnalytics(data.data) : undefined),
    [data],
  );

  return {
    data: normalizedData,
    isLoading,
    isError,
    setParamsFilter,
    dates,
    refetch,
  };
};
